import SearchEngineAdapter from 'Services/Adapters/SearchEngine/SearchEngineAdapter';

export default class CompanyAdapter extends SearchEngineAdapter {
    /**
     * Define statically the class key
     * Allows to determine the type of class without instantiating it
     */
    static get _key() {
        return 'company';
    }

    constructor(data = []) {
        super(data);
        this.key = CompanyAdapter._key;
    }

    getStructure() {
        return {
            key: this.key,
            label: window.i18n.__('Société'),
            icon: 'obj-slsy-company',
            count: 0,
            items: [],
        };
    }

    formatItem(item) {
        return {
            id: item.object.id,
            name: item.name,
            address: this.formatAddress(item.invoicing_address),
            type: item.object.sub_type,
            link: `/thirds/${item.object.sub_type}/${item.object.id}`,
            component: 'search-result-third',
            corpid: item.corp_id,
        };
    }
}
